(function () {
    'use strict';

    angular.module("imApp").factory("listService", ['$ihttp', function ($ihttp) {
        let service = {
            getList: function (parms) {
                return $ihttp.post({
                    method: 2716,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2717,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
